import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { TooltipProvider } from '@/components/ui'
import { AskHost } from '@/components/ask'
import { makeQueryClient } from '@/lib/query'
import { makeRouter } from './router'
import { closeOnIframeFocus } from '@/lib/outside'
import './styles/app.css'

closeOnIframeFocus()
const qc = makeQueryClient()
const router = makeRouter(qc)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <TooltipProvider delayDuration={300}>
        <RouterProvider router={router} />
        <AskHost />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
)
